
import { CssBaseline, ThemeProvider } from '@mui/material';
import {appTheme} from "./src/lib/mui/shared/theme";

export default ({ element, props }) => {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      {element}
    </ThemeProvider>
  )
}
